require('../style/common/async.scss');

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
require ('../scripts/glider')
//import 'tippy.js/dist/themes/light.css';
//require('../scripts/owl.carousel');


/*
let settings = {
    items:1,
    nav: true,
    smartSpeed: 100,
    dots: false,
    autoWidth: true,
    responsiveRefreshRate: 50,
    margin: 0,
    stagePadding:7,


}
$('.item-attributes').owlCarousel(settings);

*/
tippy('.klipshop-pick, .klipshop-pick-product', {
    content: KLIP_PICK,

    //followCursor: true,
    //theme: 'light',
    arrow: true,
    allowHTML: true,
})

function kaledos() {
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    window.setCookie = setCookie;
    window.getCookie = getCookie;
    if (getCookie('hidekaledos') != 1) {


        import(/* webpackChunkName: "popup" */'../components/popup').then(
                ({default: Popup}) => new Popup({
                type: 'kaledos-kaledos',
                class: 'kaledos two',
                content: $('#kaledos-kalendorius-o').html(),
                buttons: [],
                width: '870px',
            })
        );
        $('.mfp-content').css('width', '870px');
        $('.mfp-content #kaledos-kalendorius').removeClass('hidden');
        setCookie('hidekaledos', 1, 0.1);
    }
}
window.kaledos = kaledos;
$(document).ready(function () {

    if ($(".deliveryTime").length > 0) {
        setTimeout(function () {
           deliveryTime();
        }, 150);
    }

// kaip paspaudziame ant kombinaciju
     $( ".attribute_list .kli_attr" ).click(function() {
      setTimeout(function () {
          changeAttributeDeliveryTime($('#idCombination').val());
       }, 50);
    });
    $( ".klipshop-pick" ).click(function() {
        if (!$('#module-klipshop_pick-pick').length) {
            setTimeout(function () {
                location.href =KLIP_PICK_LINK
            }, 500);

        }
    });
    $( ".klipshop-pick-product" ).click(function() {
        setTimeout(function () {
            location.href =KLIP_PICK_LINK
        }, 500);
    });


    if ($(".cart-gift-add").length > 0) {
        setTimeout(function () {
           getCartGiftInfo();
        }, 150);
    }

});


function changeAttributeDeliveryTime(idCombination){

    // return false;

    if(!idCombination){
        return false;
    }
    if (typeof deliveryTimeData === "undefined") { //jei nespeja uzkrauti
        return false;
    }

    var obj = jQuery.parseJSON(deliveryTimeData);

    $.each(obj.deliveryTime, function (key, value) {
        if(value.atrId == idCombination){
            if(value.isStock == false){
                $('.deliveryTime p').html('');
                $('.deliveryTime p').hide();
            }else{
                $('.deliveryTime p').html(value.text);
                $('.deliveryTime p').show();
            }
          return true;
        }
    });
}


function getCartGiftInfo() {

        $.ajax({
        type: 'POST',
        cache: false,
        data: {
            ajax: 1,
            ajaxMode: 1,
            action: 'getCartGiftInfo'
        },
        success: function (result) {
            $('.cart-gift-add-info .produnt-errors-popop-left').html(result);
        }

    });
}


function deliveryTime() {

    $.ajax({
        type: 'POST',
        cache: false,
        data: {
            ajax: 1,
            ajaxMode: 1,
            action: 'getDeliveryTime'
        },
        success: function (result) {
            var obj = jQuery.parseJSON(result);
            if (obj.noRezult == false) {

                $.each(obj.deliveryTime, function (key, value) {

                    if (value.isSelectedAtr == true && value.isStock == true) {
                        $('.deliveryTime p').html(value.text);
                        $('.deliveryTime p').show();
                         return true;
                    }

                });
            }

        window.deliveryTimeData = result; //uzsetimam globaliam kintamajam

        }

    });
}

$( document ).ready(function() {

    if($(".klip-category-block-inner").height() > $(".klip-category-block").height()+1)
    {
        $('.klip-category-block-more').show();
    }

    $(document).on("click", '.klip-category-block-more', function (e) {
        $(".klip-category-block").css('max-height','999999px');
        $('.klip-category-block-more').hide();
    })

});



export default () => {


};
